module.exports = __webpack_public_path__ + "img/tracking.655e540c.png";